module.exports = __webpack_public_path__ + "img/re_languages.93efe953.png";